<template>
<div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Create Product</strong>
          </div>
          <b-form-group
            label="Type"
            label-for="horizType"
            description="Please enter your type."
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="horizType" type="text" placeholder="Enter Type.."></b-form-input>
          </b-form-group>
          <b-form-group
            label="Name"
            label-for="horizName"
            description="Please enter your name."
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="horizName" type="text" placeholder="Enter Name.."></b-form-input>
          </b-form-group>
          <b-form-group
            label="Description"
            label-for="horizDescription"
            :label-cols="3"
            :horizontal="true">
            <b-form-input id="horizDescription" :textarea="true" :rows="9" placeholder="Enter Description.."></b-form-input>
          </b-form-group>
          <b-form-group
            label="Status"
            label-for="status"
            :label-cols="3"
            :horizontal="true">
            <b-form-radio-group
              id="status"
              name="status">
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="status1" name="status" class="custom-control-input" value="Active">
                <label class="custom-control-label" for="status1">Active</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="status2" name="status" class="custom-control-input" value="Inactive" checked>
                <label class="custom-control-label" for="status2">Inactive</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="status3" name="status" class="custom-control-input" value="Deleted">
                <label class="custom-control-label" for="status3">Deleted</label>
              </div>
            </b-form-radio-group>
          </b-form-group>          
          <div slot="footer">
            <b-form-group
              label=""
              :label-cols="3"
              :horizontal="true">
              <b-button type="submit" variant="primary" @click="cancel()">Submit</b-button>
              <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
            </b-form-group>
          </div>
        </b-card>
    </b-col>
  </b-row>
</div>
</template>

<script>
  // import axios from 'axios'

  export default {
    name: 'productcreate',
    props: {
    },
    data: () => {
      return {
        item: {},
        errors: [],
        fields: [
          {key: 'name'},
          {key: 'email'},
          {key: 'status'}
        ]
      }
    },
    mounted () {
    },
    methods: {
      cancel () {
        this.$router.push('/products')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/ProductCreate.vue